import { render } from "./ProductCostReceivingViewModal.vue?vue&type=template&id=3a1105fa"
import script from "./ProductCostReceivingViewModal.vue?vue&type=script&lang=js"
export * from "./ProductCostReceivingViewModal.vue?vue&type=script&lang=js"

import "./ProductCostReceivingViewModal.vue?vue&type=style&index=0&id=3a1105fa&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__